<ng-content *ngIf="hasSelected" select="[table-has-selected]"></ng-content>
<ng-content *ngIf="hasSelected === false" select="[table-has-no-selected]"></ng-content>
